import useSubscribe from '@/hooks/useSubscribe';
import type { GsEvent } from '@/lib/types';

export default function EventSignupPanel({ event }: { event: GsEvent }) {
  const { status, formError, submit } = useSubscribe(`event-${event.slug || 'detail'}`, 'contact_alt');
  const played = event.status.toLowerCase().includes('played');

  return (
    <form id="event-photos-form" onSubmit={submit} className="bg-foreground-950 rounded-lg p-6 md:p-7">
      <h3 className="font-heading font-extrabold uppercase text-2xl text-background-50 leading-none">
        {played ? 'Played in this one?' : 'Get the recap'}
      </h3>
      <p className="text-foreground-300 mt-2 text-sm">
        {played ? "Get the photos and next year's date." : "We'll email you the story and photos after the event."}
      </p>
      <input type="text" name="contact_alt" className="gs-field-x" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      <input type="hidden" name="event" value={event.name} />
      <input type="email" name="email" required placeholder="Your email" className="mt-5 w-full text-sm rounded-md px-4 py-3 bg-background-50 focus:outline-none focus:ring-2 focus:ring-accent-400" />
      <button type="submit" disabled={status === 'sending'} className="mt-3 w-full bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider py-3 rounded-md whitespace-nowrap cursor-pointer disabled:opacity-60">
        {status === 'sending' ? 'Sending...' : played ? 'Send me the photos' : 'Notify me'}
      </button>
      {status === 'success' && <p className="mt-3 text-sm text-accent-400">Got it. We&apos;ll be in touch.</p>}
      {status === 'error' && <p className="mt-3 text-sm text-secondary-300">{formError}</p>}
    </form>
  );
}